export default "__VITE_ASSET__jBwa1TfS__"